<template>
  <div class="card-status-overlay">
    <p>
      <strong>
        Account Address
      </strong>
    </p>
    <p class="small">{{ cardAddress.Address1 }}<br />
    {{ cardAddress.City }}, {{ cardAddress.State && cardAddress.State.Code }} {{ cardAddress.Zip }}
    </p>
  </div>
</template>

<script>

export default {
  data() {
    return {
      cardAddress: {}
    }
  },
  created() {
    this.getAddress()
  },
  props: {
    card: Object
  },
  methods: {
    async getAddress() {
      if (this.card.AccountId) {
        try {
          const response = await this.api.get(`evedpaycards/accounts/${this.card.AccountId}/get-address`)

          if (response.status === 200) {
            this.cardAddress = response.data
          }
        } catch (error) {
          console.error(error)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .card-status-overlay {
    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }

  .row-with-border th,
  .row-with-border td {
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-list/CardAddress.vue